// src/components/projects/ChatWindow/ActionMenuPopover.js

import React from 'react';
import {
  Popover,
  Box,
  MenuItem,
  Divider,
  Typography,
  alpha,
  useTheme,
} from '@mui/material';
import {
  Edit,
  Delete,
} from '@mui/icons-material';

const ActionMenuPopover = ({
  anchorEl,
  onClose,
  actionModel,
  onUpdate,
  onDelete,
}) => {
  const theme = useTheme();

  const handleUpdate = () => {
    onClose();
    if (actionModel && onUpdate) {
      onUpdate('update', actionModel);
    }
  };

  const handleDelete = () => {
    onClose();
    if (actionModel && onDelete) {
      onDelete('delete', actionModel);
    }
  };

  return (
    <Popover
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      PaperProps={{
        sx: {
          width: 190,
          borderRadius: 2,
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
          border: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
          backgroundColor: theme.palette.background.paper,
        }
      }}
    >
      <Box sx={{ py: 0.5 }}>
        {actionModel && (
          <>
            {/* Update API Key */}
            <MenuItem
              onClick={handleUpdate}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                py: 0.8,
                px: 1.5,
                borderRadius: 1,
                mx: 0.5,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.06),
                }
              }}
            >
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: alpha(theme.palette.info.main, 0.1),
                  color: theme.palette.info.main,
                }}
              >
                <Edit sx={{ fontSize: 12 }} />
              </Box>
              <Box>
                <Typography variant="body2" fontWeight={500} fontSize="0.70rem">
                  Update API Key
                </Typography>
                
              </Box>
            </MenuItem>

            <Divider sx={{ my: 0.5, mx: 1 }} />

            {/* Delete Configuration */}
            <MenuItem
              onClick={handleDelete}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                py: 0.8,
                px: 1.5,
                borderRadius: 1,
                mx: 0.5,
                color: theme.palette.error.main,
                '&:hover': {
                  backgroundColor: alpha(theme.palette.error.main, 0.08),
                }
              }}
            >
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: alpha(theme.palette.error.main, 0.1),
                  color: theme.palette.error.main,
                }}
              >
                <Delete sx={{ fontSize: 12 }} />
              </Box>
              <Box>
                <Typography variant="body2" fontWeight={500} fontSize="0.70rem">
                  Delete Config
                </Typography>
              </Box>
            </MenuItem>
          </>
        )}
      </Box>
    </Popover>
  );
};

export default ActionMenuPopover;